<template>
  <div class="columns">
    <div
        class="column is-full is-flex"
        :class="{
          'is-justify-content-end is-align-content-end' : position === 'right',
          'is-justify-content-center is-align-content-center' : position === 'center'
        }"
    >
      <button
          class="button is-primary is-size-3 is-large has-text-weight-medium"
          :class="[ sizeClass ]"
          @click.prevent="$emit('nextTab')"
          :disabled="isClicked"
      >
        <div class="is-fullwidth">
          Próximo
          <span class="is-justify-content-end is-align-content-end has-text-right is-pulled-right">
            >
          </span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'next-button',
  data() {
    return {
      isClicked: false
    }
  },
  props: {
    position: {
      required: true,
      type: String
    },
    sizeClass: {
      required: false,
      type: String
    }
  }
}
</script>